import { authHeader } from 'services';
import { Api } from './api/axios.service';

const getAdvertisements = (partner = '') => {
  return Api.get('/advertisement', {
    params: { partner },
    headers: authHeader(),
  });
};

const createUpdateAdvertisement = (advertisement: any, id?: string) => {
  let formData = new FormData();
  const keys = Object.keys(advertisement);

  keys.forEach((key) => {
    if (advertisement[key] instanceof File) {
      formData.append(key, advertisement[key], advertisement[key].name);
    } else {
      formData.append(key, advertisement[key]);
    }
  });

  if (id) {
    return Api.put(`/advertisement/${id}`, formData, {
      headers: authHeader(),
    }).then((response) => response);
  } else {
    return Api.post('/advertisement', formData, { headers: authHeader() });
  }
};

const getAdvertisementList = (page: number, amount: number, filter: string) => {
  return Api.get(
    `/advertisement?page=${page}&amount=${amount}&filter=${filter}`,
    {
      headers: authHeader(),
    }
  );
};

const getCurrentUser = () => {
  return Api.get('/user', {
    headers: authHeader(),
  });
};

export const AdvertisementService = {
  getAdvertisements,
  getAdvertisementList,
  getCurrentUser,
  createUpdateAdvertisement,
};

